<app-navbar />

<div class="container-fluid">
  <!-- Filtros -->
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center rounded-top">
      <i class="fas fa-search fs-5 me-2 text-white"></i>
      <h2 class="fw-bold">Vistorias Em Análise</h2>
    </div>
    <div class="card-body">

      <!-- Linha com botão de filtro à esquerda e controles de paginação/itens por página à direita -->
      <div class="row mt-3" *ngIf="!erro">
        <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
          <!-- Botão Filtrar -->
          <button class="btn btn-info btn-sm me-2" type="button" (click)="showFiltros = !showFiltros">
            <i class="fas fa-filter me-1"></i> Filtrar
          </button>

          <!-- Período -->
          <div class="d-flex align-items-center gap-2 me-3">
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataInicio" />
            <span>até</span>
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim" />
            <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
              <i class="fas fa-sync-alt me-1"></i> Recarregar
            </button>
          </div>

          <div class="d-flex align-items-center gap-2 ms-auto">
            <label class="mb-0 small">Itens:</label>
            <select id="tamanhoPaginaSelect" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
              (ngModelChange)="alterarTamanhoPagina($event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>

            <span class="page-info small">
              Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}} itens)
            </span>

            <!-- Botões -->
            <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
              [disabled]="paginaAtual >= totalPaginas">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div class="row mt-2" *ngIf="showFiltros">
          <!-- <div class="col-md-3">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="filtroStatus">
              <option value="">Todos</option>
              <option value="EmAndamento">EmAndamento</option>
              <option value="Concluida">Concluido</option>
              <option value="Retornar">Retornar</option>
              <option value="Negada">Negado</option>
              <option value="Validado">Validado</option>
              <option value="Invalido">Invalido</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label">Matrícula</label>
            <input type="text" class="form-control" [(ngModel)]="filtroMatricula"
              placeholder="Matrícula do consumidor" />
          </div> -->
          <div class="col-md-3">
            <label class="form-label">Nº Vistoria</label>
            <input type="text" class="form-control" [(ngModel)]="filtroNumeroVistoria" placeholder="Nº Vistoria" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Nome Consumidor</label>
            <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor"
              placeholder="Nome do consumidor" />
          </div>
          <div class="col-md-3">
            <label class="form-label">CPF</label>
            <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
          </div>
          <div class="col-md-3">
            <label class="form-label">CNPJ</label>
            <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
          </div>
          <div class="col-md-3">
            <label class="form-label">CEP</label>
            <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Número</label>
            <input type="text" class="form-control" [(ngModel)]="filtroNumero" placeholder="Número (logradouro)" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Logradouro</label>
            <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Bairro</label>
            <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Cidade</label>
            <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Estado</label>
            <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Período de Análise</label>
            <div class="d-flex gap-2">
              <input class="form-control" type="date" [(ngModel)]="filtroDataAnaliseInicio" />
              <span>até</span>
              <input class="form-control" type="date" [(ngModel)]="filtroDataAnaliseFim" />
            </div>
          </div>
          <div class="col-12 mt-2 d-flex gap-2">
            <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
            <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Estados -->
    <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
      <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
    </div>

    <div *ngIf="servicosFiltrados.length === 0 && (filtroUsuarioId || (!filtroUsuarioId && servicos.length === 0))"
      class="alert alert-warning d-flex align-items-center gap-2">
      <i class="bi bi-folder-x"></i> Nenhum vistoria encontrado {{ filtroUsuarioId ? 'no período' : '' }}.
    </div>

    <!-- Tabela de Vistoria -->
    <div class="table-responsive" *ngIf="servicosFiltrados.length > 0">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Data</th>
            <th style="min-width: 110px;">Nº Vistoria</th>
            <th style="min-width: 120px;">Auditor</th>
            <th style="min-width: 120px;">Data Análise</th>
            <th style="min-width: 120px;">Tipo Vistoria</th>
            <th>Endereço</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let servico of servicosFiltrados; let i = index; trackBy: trackById"
            [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
            <td>
              <span class="text-primary fw-bold">
                {{ servico.dataServico | date: 'dd/MM/yyyy' }}
              </span>
            </td>
            <td>
              <span class=" n-vistoria" title="{{ formatNumeroOS(servico) }}">{{ formatNumeroOS(servico) }}</span>
            </td>
            <td>
              <span class="text-dark auditor-highlight" title="{{ getUsuarioDisplay(servico) }}">{{
                getUsuarioDisplay(servico) }}</span>
            </td>
            <td>
              <span class="analise-date">{{ getDataAnalise(servico) | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
            </td>
            <td>
              <span class="badge"
                [ngClass]="getTipoServico(servico) === 'recadastro' ? 'recadastro-badge' : 'cadastro-badge'">
                {{ getTipoServico(servico) }}
              </span>
            </td>
            <td>
              <span *ngIf="servico.endereco || servico.logradouro" class="text-secondary endereco-text"
                title="{{ getEnderecoCompleto(servico) }}">
                {{ getEnderecoCompleto(servico) }}
              </span>
              <span *ngIf="!servico.endereco && !servico.logradouro" class="text-muted">-</span>
            </td>
            <td>
              <div class="status-wrapper d-flex align-items-center justify-content-center flex-column">
                <i class="status-icon" [ngClass]="{
                   'bi-check-circle-fill status-validado': servico.status?.toLowerCase() === 'validado',
                   'bi-exclamation-triangle-fill status-invalido': servico.status?.toLowerCase() === 'invalido',
                   'bi-clock-fill status-pendente': servico.status?.toLowerCase() === 'pendente',
                   'bi-x-octagon-fill status-negado text-danger': servico.status?.toLowerCase() === 'negado',
                   'bi-dash-circle-fill status-ausente text-muted': servico.status?.toLowerCase() === 'ausente',
                   'bi-question-circle-fill text-muted': !servico.status || !['validado', 'pendente', 'invalido', 'negado', 'ausente', 'analisando'].includes(servico.status?.toLowerCase()),
                   'bi-hourglass-split status-analisando': servico.status?.toLowerCase() === 'analisando'
                 }" [title]="servico.status || 'Status não definido'">
                </i>
                <!-- Texto explicativo quando em análise -->
                <small *ngIf="servico.status?.toLowerCase() === 'analisando'"
                  class="status-label text-analisando">Analisando</small>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center gap-2 justify-content-center">
                <button class="btn btn-outline-primary btn-xs px-2 py-1" style="font-size:0.95rem;"
                  (click)="verDetalhes(servico)" title="Visualizar detalhes">
                  <i class="bi bi-eye me-1"></i>
                </button>

                <!-- Botão visível apenas para SuperAdministrador quando o status for 'Analisando' -->
                <button *ngIf="isSuperAdministrador && (servico.status?.toLowerCase() === 'analisando')"
                  class="btn btn-outline-warning btn-xs px-2 py-1" style="font-size:0.95rem;"
                  (click)="alterarStatusParaPendente(servico)" title="Marcar como Pendente">
                  <i class="bi bi-exclamation-triangle-fill me-1"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Controles de Paginação -->
    <div class="pagination-container mt-3" *ngIf="servicosFiltrados.length > 0">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Informações sobre registros -->
        <div class="pagination-info">
          <span class="text-muted">
            <i class="bi bi-info-circle me-1"></i>
            Mostrando {{getItemInicio()}} a {{getItemFim()}} de {{totalItens}} registros
          </span>
        </div>

        <!-- Seletor de itens por página -->
        <div class="page-size-selector">
          <label class="me-2">Itens por página:</label>
          <select class="form-select form-select-sm d-inline-block w-auto" [(ngModel)]="tamanhoPagina"
            (ngModelChange)="alterarTamanhoPagina($event)">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
          </select>
        </div>

        <!-- Controles de navegação -->
        <div class="pagination-controls" *ngIf="totalPaginas > 1">
          <nav aria-label="Navegação de páginas">
            <ul class="pagination pagination-sm mb-0">
              <!-- Primeira página -->
              <li class="page-item" [class.disabled]="paginaAtual === 1">
                <button class="page-link" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1">
                  <i class="fas fa-angle-double-left"></i>
                </button>
              </li>

              <!-- Página anterior -->
              <li class="page-item" [class.disabled]="paginaAtual === 1">
                <button class="page-link" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">
                  <i class="fas fa-angle-left"></i>
                </button>
              </li>

              <!-- Páginas numeradas -->
              <li class="page-item" *ngFor="let pagina of obterPaginas()" [class.active]="pagina === paginaAtual">
                <button class="page-link" (click)="irParaPagina(pagina)">
                  {{pagina}}
                </button>
              </li>

              <!-- Próxima página -->
              <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
                <button class="page-link" (click)="proximaPagina()" [disabled]="paginaAtual === totalPaginas">
                  <i class="fas fa-angle-right"></i>
                </button>
              </li>

              <!-- Última página -->
              <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
                <button class="page-link" (click)="irParaPagina(totalPaginas)"
                  [disabled]="paginaAtual === totalPaginas">
                  <i class="fas fa-angle-double-right"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <!-- Spinner de carregamento -->
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Processando, por favor aguarde... </p>
  </ngx-spinner>

  <!-- Modal de detalhes do vistoria -->
  <div class="modal fade show" tabindex="-1"
    [ngStyle]="{display: servicoDetalhes ? 'flex' : 'none', background: 'rgba(0,0,0,0.4)', alignItems: 'center', justifyContent: 'center'}"
    *ngIf="servicoDetalhes">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content" #conteudoModal>
        <div class="modal-header bg-gradient-info text-white">
          <h5 class="modal-title">
            <i class="bi bi-file-earmark-text me-2"></i>
            Detalhes da vistoria
          </h5>
          <button type="button" class="btn-close" (click)="fecharModalDetalhes()"></button>
        </div>
        <div class="modal-body">
          <form class="form px-2 py-2">

            <div class="mb-3">
              <div class="p-3 rounded bg-gradient-info d-flex align-items-center">
                <i class="fas fa-search fs-4 me-3"></i>
                <div>
                  <div class="small">Vistoria</div>
                  <div class="h5 fw-bold mb-0">n° {{ formatNumeroOS(servicoDetalhes) }}</div>
                </div>
              </div>
            </div>
            <fieldset>
              <legend class="mb-2">Dados do Consumidor</legend>
              <div class="grid-4 mb-2">
                <div *ngIf="servicoDetalhes.matricula">
                  <label>Matrícula</label>
                  <input type="text" [value]="servicoDetalhes.matricula" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Nome do Consumidor</label>
                  <input type="text" [value]="servicoDetalhes.nomeConsumidor || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>
                    <ng-container *ngIf="servicoDetalhes.tipoUtilizacao === 'DOMICILIAR'; else cnpjLabel">
                      CPF
                    </ng-container>
                    <ng-template #cnpjLabel>CNPJ</ng-template>
                  </label>
                  <input type="text"
                    [value]="servicoDetalhes.tipoUtilizacao === 'DOMICILIAR' ? maskCpf(servicoDetalhes.cpf) : maskCnpj(servicoDetalhes.cnpj)"
                    readonly class="campo-readonly" />
                </div>
              </div>

              <div class="grid-4 mb-2">
                <div *ngIf="servicoDetalhes.email">
                  <label>Email</label>
                  <input type="text" [value]="servicoDetalhes.email || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Telefone</label>
                  <input type="text" [value]="maskTelefone(servicoDetalhes.telefone)" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Ciclo de Leitura</label>
                  <input type="text" [value]="servicoDetalhes.cicloDeLeitura || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Número Imóvel</label>
                  <input type="text" [value]="servicoDetalhes.numeroImovel || '-'" readonly class="campo-readonly" />
                </div>
              </div>

              <div class="grid-4 mb-2">
                <div>
                  <label>Referência</label>
                  <input type="text" [value]="servicoDetalhes.referencia || '-'" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.dataCadastroOriginal">
                  <label>Data Cadastro</label>
                  <input type="text" [value]="servicoDetalhes.dataCadastroOriginal | date: 'dd/MM/yyyy HH:mm'" readonly
                    class="campo-readonly" />
                </div>
                <div>
                  <label>Loja/Loc</label>
                  <input type="text" [value]="servicoDetalhes.lojLoc || '-'" readonly class="campo-readonly" />
                </div>
              </div>

              <div class="grid-3 mb-2">
                <div>
                  <label>Sistema de Abastecimento</label>
                  <input type="text" [value]="servicoDetalhes.sistemaAbastecimento || '-'" readonly
                    class="campo-readonly" />
                </div>
                <div>
                  <label>Tipo de Abastecimento</label>
                  <input type="text" [value]="servicoDetalhes.tipoAbastecimento || '-'" readonly
                    class="campo-readonly" />
                </div>
                <div>
                  <label>Tipo Utilização</label>
                  <input type="text" [value]="servicoDetalhes.tipoUtilizacao || '-'" readonly class="campo-readonly" />
                </div>
              </div>
            </fieldset>

            <fieldset
              *ngIf="servicoDetalhes.numeroHidrometro || servicoDetalhes.marcacao || servicoDetalhes.seloReloj || servicoDetalhes.seloVirola || servicoDetalhes.ramal || servicoDetalhes.direto !== undefined || servicoDetalhes.haCisterna !== undefined || servicoDetalhes.haReservatorioElevado !== undefined || servicoDetalhes.tipoEconomia || servicoDetalhes.haPiscina !== undefined">
              <legend class="mb-2">ÁGUA</legend>
              <div class="grid-3 mb-2">
                <div>
                  <label>Nº Hidrômetro</label>
                  <input type="text" [value]="servicoDetalhes.numeroHidrometro || '-'" readonly
                    class="campo-readonly" />
                </div>
                <div>
                  <label>Marcação</label>
                  <input type="text" [value]="servicoDetalhes.marcacao || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Selo Reloj.</label>
                  <input type="text" [value]="servicoDetalhes.seloReloj || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Selo Virola</label>
                  <input type="text" [value]="servicoDetalhes.seloVirola || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Ramal</label>
                  <input type="text" [value]="servicoDetalhes.ramal || '-'" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Direto</label>
                  <input type="text"
                    [value]="servicoDetalhes.direto === undefined ? '-' : (servicoDetalhes.direto ? 'Sim' : 'Não')"
                    readonly class="campo-readonly" />
                </div>
              </div>

              <div class="grid-1 mb-2">

                <fieldset *ngIf="servicoDetalhes.haCisterna !== undefined">
                  <h4>Cisterna</h4>
                  <label>Há cisterna?</label>
                  <input type="text" [value]="servicoDetalhes.haCisterna ? 'Sim' : 'Não'" readonly
                    class="campo-readonly" />
                  <div *ngIf="servicoDetalhes.haCisterna && servicoDetalhes.capacidadeCisternaInformada">
                    <label>Capacidade Informada</label>
                    <input type="text" [value]="servicoDetalhes.capacidadeCisternaInformada" readonly
                      class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.haCisterna && servicoDetalhes.observacoesCisterna">
                    <label>Observações</label>
                    <textarea readonly class="campo-readonly"
                      rows="2">{{ servicoDetalhes.observacoesCisterna }}</textarea>
                  </div>
                </fieldset>

                <fieldset *ngIf="servicoDetalhes.haReservatorioElevado !== undefined">
                  <h4>Reservatório Elevado</h4>
                  <label>Há Reservatórios Elevados?</label>
                  <input type="text" [value]="servicoDetalhes.haReservatorioElevado ? 'Sim' : 'Não'" readonly
                    class="campo-readonly" />
                  <div
                    *ngIf="servicoDetalhes.haReservatorioElevado && servicoDetalhes.capacidadeReservatorioElevadoInformada">
                    <label>Capacidade Informada</label>
                    <input type="text" [value]="servicoDetalhes.capacidadeReservatorioElevadoInformada" readonly
                      class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.haReservatorioElevado && servicoDetalhes.observacoesReservatorioElevado">
                    <label>Observações</label>
                    <textarea readonly class="campo-readonly"
                      rows="2">{{ servicoDetalhes.observacoesReservatorioElevado }}</textarea>
                  </div>
                </fieldset>

                <fieldset *ngIf="servicoDetalhes.haPiscina !== undefined">
                  <h4>Piscina</h4>
                  <label>Existe Piscina?</label>
                  <input type="text" [value]="servicoDetalhes.haPiscina ? 'Sim' : 'Não'" readonly
                    class="campo-readonly" />
                  <div *ngIf="servicoDetalhes.haPiscina && servicoDetalhes.dimensoesPiscina">
                    <label>Dimensões:</label>
                    <input type="text" [value]="servicoDetalhes.dimensoesPiscina" readonly class="campo-readonly" />
                  </div>
                </fieldset>
              </div>
            </fieldset>

            <fieldset>
              <legend class="mb-2">Economias</legend>
              <div class="grid-3 mb-2">
                <div>
                  <label>Tipos de Economias</label>
                  <input type="text" [value]="servicoDetalhes.tipoEconomia || '-'" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.dUnica">
                  <label>Sub Categoria</label>
                  <input type="text" [value]="servicoDetalhes.dUnica" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Número de Economias</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeEconomias || '-'" readonly
                    class="campo-readonly" />
                </div>
              </div>

              <!-- DOMICILIAR -->
              <div class="grid-4 mb-2"
                *ngIf="servicoDetalhes.tipoEconomia === 'DOMICILIAR' && (servicoDetalhes.numeroDeQuartos || servicoDetalhes.numeroDeSalas || servicoDetalhes.numeroWcPav)">
                <div *ngIf="servicoDetalhes.numeroDeQuartos">
                  <label>Nº Quartos</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.numeroDeSalas">
                  <label>Nº Salas</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeSalas" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.numeroWcPav">
                  <label>Nº WC/PAV</label>
                  <input type="text" [value]="servicoDetalhes.numeroWcPav" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.numeroDeBoxes">
                  <label>Nº Boxes</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
                </div>
              </div>

              <!-- COMERCIO -->
              <div class="grid-3 mb-2"
                *ngIf="servicoDetalhes.tipoEconomia === 'COMERCIO'">
                <div>
                  <label>Nº Salas/Lojas/Quartos</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Tipo Comércio</label>
                  <input type="text" [value]="servicoDetalhes.tipoComercio" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Alunos</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeAlunos" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Nº Boxes</label>
                  <input type="text" [value]="servicoDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Nº Banheiro</label>
                  <input type="text" [value]="servicoDetalhes.banheiros" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Área (m²)</label>
                  <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
                </div>
              </div>


             <!-- Indústria -->
            <div class="grid-3 mb-2"
              *ngIf="servicoDetalhes.tipoEconomia === 'INDUSTRIA'">
              <div>
                <label>Tipo Indústria</label>
                <input type="text" [value]="servicoDetalhes.tipoIndustria" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>
            </fieldset>

            <fieldset>
              <legend class="mb-2">ESGOTO</legend>
              <div>
                <label>Tem coletor?</label>
                <input type="text" [value]="servicoDetalhes.haColetor ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
              </div>

              <div *ngIf="servicoDetalhes.haColetor">
                <label>Efluente encaminhado para:</label>
                <div class="grid-4 mb-2">
                  <div *ngIf="servicoDetalhes.coletor === 'true'">
                    <label>Coletor</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.gap === 'true'">
                    <label>GAP</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.rio === 'true'">
                    <label>RIO</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.valao === 'true'">
                    <label>VALÃO</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.focaFiltro === 'true'">
                    <label>Fossa/Filtro</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.vala === 'true'">
                    <label>Vala</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                  <div *ngIf="servicoDetalhes.sumidouro === 'true'">
                    <label>Sumidouro</label>
                    <input type="text" value="Sim" readonly class="campo-readonly" />
                  </div>
                </div>
                <div *ngIf="servicoDetalhes.tipoValaValao">
                  <label>A vala ou valão é de:</label>
                  <input type="text" [value]="servicoDetalhes.tipoValaValao" readonly class="campo-readonly" />
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend class="mb-2">Endereço</legend>
              <div class="grid-3 mb-2">
                <div>
                  <label>Logradouro:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.logradouro || servicoDetalhes.logradouro || '-'" readonly>
                </div>
                <div>
                  <label>Número:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.numero || servicoDetalhes.numero || '-'" readonly>
                </div>
                <div>
                  <label>Bairro:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.bairro || servicoDetalhes.bairro || '-'" readonly>
                </div>
              </div>
              <div class="grid-3 mb-2">
                <div>
                  <label>Cidade:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.cidade || servicoDetalhes.cidade || '-'" readonly>
                </div>
                <div>
                  <label>Estado:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.estado || servicoDetalhes.estado || '-'" readonly>
                </div>
                <div>
                  <label>CEP:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.cep || servicoDetalhes.cep || '-'" readonly>
                </div>
              </div>
              <div class="grid-1 mb-2" *ngIf="servicoDetalhes.endereco?.complemento || servicoDetalhes.complemento">
                <div>
                  <label>Complemento:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.endereco?.complemento || servicoDetalhes.complemento || '-'" readonly>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend class="mb-2">FOTOS DO LOCAL</legend>
              <div class="fotos-grid mb-2">
                <div class="foto-item" *ngFor="let foto of servicoDetalhes.fotos">
                  <div class="foto-wrapper" style="display: flex; flex-direction: column; align-items: center;">
                    <img [src]="getFullImageUrl(foto.url)" alt="Foto do Local" class="foto-local"
                      [style.transform]="'rotate(' + getRotacaoMiniatura(foto.url) + 'deg)'"
                      [style.transition]="'transform 0.3s'" (click)="abrirModalFoto(foto.url)" />
                  </div>
                  <div style="display: flex; gap: 6px; margin-top: 6px; justify-content: center; width: 100%;">
                    <a *ngIf="foto?.latitude && foto?.longitude"
                      [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude" target="_blank"
                      class="btn btn-outline-success btn-xs px-2 py-1">
                      <i class="bi bi-geo-alt-fill"></i>
                      <span style="margin-left:6px;">Mapa</span>
                    </a>
                    <button type="button" class="btn btn-outline-secondary btn-xs px-2 py-1"
                      (click)="girarMiniatura(foto.url, 'esquerda')" title="Girar à esquerda">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-xs px-2 py-1"
                      (click)="girarMiniatura(foto.url, 'direita')" title="Girar à direita">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="!servicoDetalhes.fotos?.length" class="alert alert-warning">
                Nenhuma foto disponível.
              </div>
            </fieldset>

            <fieldset>
              <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
              <div *ngIf="servicoDetalhes.outrasInformacoes">
                <label>Descrição da Conclusão</label>
                <textarea readonly class="campo-readonly" rows="6">{{ servicoDetalhes.outrasInformacoes }}</textarea>
              </div>
            </fieldset>

            <fieldset class="fotos">
              <legend class="mb-2">FOTOS DE DOCUMENTOS</legend>
              <div class="fotos-grid mb-2">
                <div class="foto-item" *ngFor="let fotoDoc of servicoDetalhes.fotosDocumento">
                  <div class="foto-wrapper" style="display: flex; flex-direction: column; align-items: center;">
                    <img [src]="getFullImageUrl(fotoDoc.url)" alt="Foto do Documento" class="foto-local"
                      [style.transform]="'rotate(' + getRotacaoMiniatura(fotoDoc.url) + 'deg)'"
                      [style.transition]="'transform 0.3s'" (click)="abrirModalFoto(fotoDoc.url)" />
                  </div>
                  <div style="display: flex; gap: 6px; margin-top: 6px; justify-content: center; width: 100%;">
                    <a *ngIf="fotoDoc?.latitude && fotoDoc?.longitude"
                      [href]="'https://www.google.com/maps?q=' + fotoDoc.latitude + ',' + fotoDoc.longitude"
                      target="_blank" class="btn btn-outline-success btn-xs px-2 py-1">
                      <i class="bi bi-geo-alt-fill"></i>
                      <span style="margin-left:6px;">Mapa</span>
                    </a>
                    <button type="button" class="btn btn-outline-secondary btn-xs px-2 py-1"
                      (click)="girarMiniatura(fotoDoc.url, 'esquerda')" title="Girar à esquerda">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-xs px-2 py-1"
                      (click)="girarMiniatura(fotoDoc.url, 'direita')" title="Girar à direita">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="!servicoDetalhes.fotosDocumento?.length" class="alert alert-warning">
                Nenhuma foto disponível.
              </div>
            </fieldset>


            <fieldset>
              <legend class="mb-2">Localização</legend>
              <div class="grid-2 mb-2">
                <div>
                  <label>Início</label>
                  <div *ngIf="servicoDetalhes.latitudeInicio && servicoDetalhes.longitudeInicio"
                    class="coordenadas-label">
                    <span class="badge bg-light text-dark">Lat: {{ servicoDetalhes.latitudeInicio }} | Lng: {{
                      servicoDetalhes.longitudeInicio }}</span>
                  </div>
                  <a *ngIf="servicoDetalhes.latitudeInicio && servicoDetalhes.longitudeInicio"
                    [href]="'https://www.google.com/maps?q=' + servicoDetalhes.latitudeInicio + ',' + servicoDetalhes.longitudeInicio"
                    target="_blank" class="btn btn-outline-success btn-sm ms-1">
                    <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                  </a>
                  <span *ngIf="!servicoDetalhes.latitudeInicio || !servicoDetalhes.longitudeInicio"
                    class="text-muted">Sem
                    localização</span>
                  <div class="mt-2">
                    <label>Data/Hora Início</label>
                    <input type="text" [value]="servicoDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss'" readonly
                      class="campo-readonly" />
                  </div>
                </div>
                <div>
                  <label>Fim</label>
                  <div *ngIf="servicoDetalhes.latitudeFim && servicoDetalhes.longitudeFim" class="coordenadas-label">
                    <span class="badge bg-light text-dark">Lat: {{ servicoDetalhes.latitudeFim }} | Lng: {{
                      servicoDetalhes.longitudeFim }}</span>
                  </div>
                  <a *ngIf="servicoDetalhes.latitudeFim && servicoDetalhes.longitudeFim"
                    [href]="'https://www.google.com/maps?q=' + servicoDetalhes.latitudeFim + ',' + servicoDetalhes.longitudeFim"
                    target="_blank" class="btn btn-outline-danger btn-sm ms-1">
                    <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                  </a>
                  <span *ngIf="!servicoDetalhes.latitudeFim || !servicoDetalhes.longitudeFim" class="text-muted">Sem
                    localização</span>
                  <div class="mt-2">
                    <label>Data/Hora Fim</label>
                    <input type="text" [value]="servicoDetalhes.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss'" readonly
                      class="campo-readonly" />
                  </div>
                </div>
              </div>
              <div class="map-container">
                <div id="map-servico"></div>
              </div>
            </fieldset>
            <fieldset>
              <legend class="mb-2">Dados do Acompanhante</legend>
              <div class="grid-3 mb-2">
                <div>
                  <label>Nome:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.nomeAcompanhante || '-'" readonly>
                </div>
                <div>
                  <label>CPF:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.cpfAcompanhante ? maskCpf(servicoDetalhes.cpfAcompanhante) : '-'" readonly>
                </div>
                <div>
                  <label>Telefone:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.telefoneAcompanhante ? maskTelefone(servicoDetalhes.telefoneAcompanhante) : '-'"
                    readonly>
                </div>
              </div>
              <div>
                <label>Assinatura do Acompanhante:</label>
                <div class="signature-container">
                  <img *ngIf="servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante"
                    [src]="getFullImageUrl(servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante)"
                    alt="Assinatura do Acompanhante" class="signature-image"
                    (click)="abrirModalFoto(servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante)">
                  <div *ngIf="!servicoDetalhes.assinaturaAcompanhante?.url && !servicoDetalhes.assinaturaAcompanhante"
                    class="sem-dados-campo">
                    Não informado
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend class="mb-2">Dados do Vistoriador</legend>
              <div class="grid-2 mb-2">
                <div>
                  <label>Nome:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.nomeVistoriador || servicoDetalhes.nomeVistoriante || '-'" readonly>
                </div>
                <div>
                  <label>Data da vistoria:</label>
                  <input type="text" class="form-control campo-readonly"
                    [value]="servicoDetalhes.dataServico || servicoDetalhes.dataCadastro || servicoDetalhes.dataRecadastro ? 
                               ((servicoDetalhes.dataServico || servicoDetalhes.dataCadastro || servicoDetalhes.dataRecadastro) | date: 'dd/MM/yyyy HH:mm') : '-'" readonly>
                </div>
              </div>
              <div class="grid-1 vistoriador-foto mb-2">
                <div>
                  <label>Foto do Vistoriador:</label>
                  <div class="foto-vistoriador">
                    <img *ngIf="servicoDetalhes.fotoVistoriador || servicoDetalhes.fotoVistoriante"
                      [src]="getFullImageUrl(servicoDetalhes.fotoVistoriador || servicoDetalhes.fotoVistoriante)"
                      alt="Foto do Vistoriador" class="foto-vistoriador"
                      (click)="abrirModalFoto(servicoDetalhes.fotoVistoriador || servicoDetalhes.fotoVistoriante)">
                    <div *ngIf="!servicoDetalhes.fotoVistoriador && !servicoDetalhes.fotoVistoriante"
                      class="sem-dados-campo">
                      Não disponível
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label>Assinatura do Vistoriador:</label>
                <div class="signature-container">
                  <img *ngIf="servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url"
                    [src]="getFullImageUrl(servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url)"
                    alt="Assinatura do Vistoriador" class="signature-image"
                    (click)="abrirModalFoto(servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url)">
                  <div *ngIf="!servicoDetalhes.assinaturaVistoriador && !servicoDetalhes.assinaturaVistoriante?.url"
                    class="sem-dados-campo">
                    Não informado
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger me-2" (click)="exportarServicoParaPDF()">
            <i class="bi bi-file-earmark-pdf-fill me-1"></i> Exportar PDF
          </button>
          <button type="button" class="btn btn-secondary" (click)="fecharModalDetalhes()">Fechar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de visualização de foto ampliada -->
  <div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto" (click)="fecharModalFoto()">
    <div class="modal-foto-content" (click)="$event.stopPropagation()">
      <button type="button" class="btn-close-foto" (click)="fecharModalFoto()">
        <i class="fas fa-times"></i>
      </button>
      <img [src]="getFullImageUrl(fotoSelecionada)" alt="Foto Ampliada" class="foto-ampliada">
    </div>
  </div>

  <!-- Container oculto para exportação completa -->
  <div #conteudoCompleto style="position: absolute; top: -9999px; left: -9999px; width: 1000px;">
    <div [innerHTML]="htmlCompletoParaExportar"></div>
  </div>